export enum BarGap {
    None,
    Small,
    Medium,
    Large,
}
